module.exports = __webpack_public_path__ + "static/quickFilter-c255d9fd2675b65b4e77c72df81f4efa.gif";